var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarte = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.103 10.986c-.714 0-1.431-.129-2.043-.39-.396-.168-.591-.648-.432-1.059a.809.809 0 0 1 .432-.462.771.771 0 0 1 .6 0c.837.36 2.049.363 2.886.003a.771.771 0 0 1 .6 0 .795.795 0 0 1 .432.46c.159.413-.036.89-.432 1.058-.612.261-1.33.39-2.043.39z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M7.577 11.997l.077.231-4.16 1.428a.165.165 0 0 0-.115.138l-.863 6.516a.165.165 0 0 0 .057.147c.02.021.078.06.162.036 2.658-.798 3.756-1.11 4.224-1.227l.74-6.999-.122-.27zm9.701 7.335l4.039 1.284a.16.16 0 0 0 .162-.03c.02-.02.069-.069.056-.15l-.902-6.693a.177.177 0 0 0-.114-.138l-3.897-1.413-.292.06.244-.024.704 7.104zm-5.267 1.98a.68.68 0 0 1-.22-.033l-4.545-1.587c-.396.09-2.85.81-4.37 1.266a.65.65 0 0 1-.618-.126.666.666 0 0 1-.228-.588l.864-6.516a.654.654 0 0 1 .44-.534L7.5 11.77a.518.518 0 0 1 .684.549l-.732 6.93 4.503 1.57a.166.166 0 0 0 .108 0l4.695-1.522a.378.378 0 0 1 .03-.009l-.696-7.008a.523.523 0 0 1 .696-.546l3.9 1.416a.651.651 0 0 1 .429.531l.903 6.687a.653.653 0 0 1-.228.591.644.644 0 0 1-.624.123l-4.155-1.32a.166.166 0 0 0-.108 0l-4.692 1.521a.584.584 0 0 1-.201.03z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M12.065 21.294a.242.242 0 0 1-.243-.243v-4.416c0-.135.108-.246.243-.246s.243.11.243.246v4.416a.242.242 0 0 1-.243.243"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M12.09 3.22c-.695 0-1.376.141-2.015.411a5.176 5.176 0 0 0-1.644 1.12A5.21 5.21 0 0 0 6.91 8.44a5.22 5.22 0 0 0 1.038 3.131c.039.048 1.224 1.545 3.627 4.57.249.311.777.314 1.035 0l3.612-4.552a5.245 5.245 0 0 0 1.05-3.15 5.201 5.201 0 0 0-1.518-3.69 5.154 5.154 0 0 0-3.663-1.53m0 13.66c-.345 0-.681-.166-.897-.436-3.64-4.58-3.64-4.58-3.651-4.602a5.662 5.662 0 0 1-1.12-3.402c0-.77.15-1.518.448-2.223a5.56 5.56 0 0 1 1.212-1.809 5.657 5.657 0 0 1 1.803-1.227 5.687 5.687 0 0 1 4.413 0 5.629 5.629 0 0 1 1.8 1.227c.522.52.93 1.128 1.215 1.81a5.746 5.746 0 0 1-.705 5.672l-3.618 4.554a1.155 1.155 0 0 1-.9.435"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarte);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carte.16fcc0f0d41c90ca181a22c397bde725.svg";